<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useSourceStore } from "@core/stores/source.store"
import { storeToRefs } from "pinia"
import { useI18n } from "vue-i18n"
import { useEventBus } from "@vueuse/core"

// ================================
// TYPES & INTERFACES
// ================================
interface Props {
    /**
     * Identifiant du compteur
     */
    meterId: string
}

// ================================
// PROPS & EMITS
// ================================
const props = defineProps<Props>()

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Informations générales du compteur",
        },
    },
})

// ================================
// COMPOSABLES
// ================================
const sourceStore = useSourceStore()
const { isFetchingSourceById } = storeToRefs(sourceStore)

// ================================
// BUSINESS LOGIC
// ================================
/**
 * Écoute l'event bus pour recharger la source
 */
const bus = useEventBus<string>("update:source_informations")
bus.on((sourceId: string) => {
    if (sourceId === props.meterId) {
        sourceStore.fetchSourceById({
            _id_source: sourceId,
        })
    }
})
</script>

<template>
    <div class="meter-info-wrapper flex flex-col gap-16">
        <!-- ================================ -->
        <!-- EN-TÊTE -->
        <!-- ================================ -->
        <HeaderPageSource
            :title="t('title')"
            :source-id="meterId"
            icon="pi pi-info-circle"
        />

        <!-- ================================ -->
        <!-- CONTENU - SKELETON OU CARTE COMPTEUR -->
        <!-- ================================ -->
        <BaseSkeleton v-if="isFetchingSourceById" width="100%" height="40rem" />
        <MeterCard v-else :meter-id="meterId" />
    </div>
</template>
